import { Component, app, ojs, payload, v } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import { eParse } from "../../helpers";
import { dc, gc, uc } from "../../declarations";
import { $e } from "../../ojs.events";
import FormField from "../Blocks/FormField";

const h = app("h");
const broker = app("broker");

ojs(FormField);

export default class WithdrawCapaForm extends Component {
    renderForm(...args) {
        return h.div(
            h.FormField({
                type: "number",
                id: "capa-withdraw-amount",
                oninput: this.method("toCost", "${this}"),
                label: { value: `Capa Amount (${dc.capaSymbol})` },
                helpText: { value: `Amount of capa to withdraw` },
                dependencies: ["cwf-capa-withdraw-price"],
                ff_dep_hook: "cwf-capa-withdraw-amount",
            }),
            h.FormField({
                type: "number",
                id: "capa-withdraw-price",
                oninput: this.method("toCapa", "${this}"),
                label: { value: `Cash Value (${dc.userCurrency})` },
                helpText: { value: `Amount you want to receive` },
                dependencies: ["cwf-capa-withdraw-amount"],
                ff_dep_hook: "cwf-capa-withdraw-price",
            }),
            h.div(
                {
                    class: "mb-3 p-3 bg-light rounded-3 d-flex align-items-center justify-content-between border border-light-subtle",
                },
                h.div(
                    h.small(
                        {
                            class: "text-muted d-block text-uppercase fw-bold mb-1",
                            style: "font-size: 0.75rem;",
                        },
                        "Capa Balance:",
                    ),
                    v(uc.capa, (capa) => {
                        const bal = capa?.value?.balance ?? 0;
                        const kesEquivalent = Math.floor(
                            bal *
                                (window.systemConfig?.capaExchangeRate ?? 0.01),
                        );
                        return h.span(
                            { class: "fw-bold fs-6 text-dark" },
                            `${bal} ${dc.capaSymbol} (KES ${kesEquivalent})`,
                        );
                    }),
                ),
                h.i({ class: "bi bi-wallet2 text-primary fs-3" }),
            ),
            h.div(
                {
                    class: "mb-3 mt-3 p-3 bg-light rounded-3 d-flex align-items-center justify-content-between border border-light-subtle",
                },
                h.div(
                    h.small(
                        {
                            class: "text-muted d-block text-uppercase fw-bold mb-1",
                            style: "font-size: 0.75rem;",
                        },
                        "Send to M-Pesa Number:",
                    ),
                    h.span(
                        { class: "fw-bold fs-6 text-dark" },
                        gc.user?.value?.phone ?? "",
                    ),
                ),
                h.i({ class: "bi bi-phone-fill text-success fs-3" }),
            ),
            h.small(
                { class: "form-text text-muted d-block mt-2 mb-3 px-1 fw-500" },
                h.i({ class: "bi bi-info-circle me-1 text-warning" }),
                "Note: Transfer cost will also be deducted from your wallet.",
            ),
            ...args,
        );
    }

    toCapa(elem) {
        let input = dom.id("capa-withdraw-amount");
        if (!input) return;
        input.value =
            elem.value == ""
                ? ""
                : Math.floor(
                      elem.value /
                          (window.systemConfig?.capaExchangeRate ?? 0.01),
                  );
        input.dispatchEvent(new CustomEvent("dependencyInput"));
    }

    toCost(elem) {
        let input = dom.id("capa-withdraw-price");
        if (!input) return;
        input.value =
            elem.value == ""
                ? ""
                : Math.ceil(
                      elem.value *
                          (window.systemConfig?.capaExchangeRate ?? 0.01),
                  );
        input.dispatchEvent(new CustomEvent("dependencyInput"));
    }

    $$capa = {
        withdrawn: (ed, event) => {
            let data = eParse(ed);
            dom.id(data.meta.buttons.left)?.click();
        },

        needs: {
            withdrawForm: (ed, event) => this.showForm(ed, event),
        },

        has: {
            withdrawError: (ed, event) => {
                let data = eParse(ed);
                const btn = dom.id(data.meta.buttons.right);

                dom.enable(btn);
                dom.put("Withdraw", btn);
            },
        },
    };

    async showForm(ed, event) {
        let options = new tool.ModalOptions();
        options.buttons.right.text = "Withdraw";
        options.classes.buttons.right = "btn btn-danger";

        options.staticBackdrop();

        const { buttons } = tool.modal(
            "Capa To Mpesa",
            this.renderForm(),
            options,
        );

        buttons.right.button.addEventListener("click", function () {
            dom.disable(this);
            dom.put("Processing...", this);

            broker.send(
                $e.capa.needs.to.initiateWithdraw,
                payload(
                    {
                        amount: dom.id("capa-withdraw-amount")?.value ?? 0,
                        phone: gc.user?.value?.phone ?? "",
                    },
                    {
                        buttons: {
                            left: buttons.left.button.id,
                            right: buttons.right.button.id,
                        },
                    },
                ),
            );
        });
    }
}

ojs(WithdrawCapaForm);
